'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = require('./Radio');

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Radio2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-radio/lib/index.js
// module id = 751
// module chunks = 0